import { BadgeProps } from "@mui/material/Badge";

export type FilterType = "all" | "in_progress" | "completed" | "awaiting_input" | "failed";

export type JobCounts = Record<FilterType, number>;

export const filterLabels: Record<FilterType, string> = {
  all: "All",
  in_progress: "In Progress",
  completed: "Completed",
  awaiting_input: "Awaiting Input",
  failed: "Failed",
};

export type BadgeColor = BadgeProps["color"];
